import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Button, Tooltip, } from 'antd';

import { Application } from "@yulintu/freesia-bootstrap";

import useDesigner from "../hooks/useDesigner";
import useDesignerMessage from "../hooks/useDesignerMessage";

import ActionDraw from "../plugins/ActionDraw";

export default function Addon(props) {

    const designer = useDesigner();
    const [action, setAction] = useState(designer.action);

    useDesignerMessage(e => {
        setAction(e);
    }, "actionChanged");

    return <>
        <Tooltip title="矩形" placement="bottom">
            <Button
                className='btn-switch'
                type={action?.modelType === "PlotRectangleModel" ? "primary" : "default"}
                onClick={e => designer.action = new ActionDraw(designer, { modelType: "PlotRectangleModel" })}
            >
                <Application.SystemSvgIcon type="juxing1" />
            </Button>
        </Tooltip>
    </>
}